/**
 * Takes a civic object and converts the inside into a single address string.
 * @param {object} civic - object sent inside an Alert's location
 * @returns {string} A readable address
 */
export const getCopyableCivicAddress = civic => {
  if (!civic) return null;
  const { street_1, street_2, city, state, zip_code } = civic;
  let street = '';
  if (street_1) {
    if (street_2) {
      street = `${street_1} ${street_2},`;
    } else {
      street = `${street_1},`;
    }
  }

  const cityString = city ? `${city},\u00A0` : '';
  const stateString = state ? state : '';
  const zip = zip_code ? zip_code : '';

  return `${street} ${cityString}${stateString} ${zip}`.trim();
};
